import { GOScheduleMenu, SearchUniversalPreviewMenusReq } from '@types'
import { Moment } from 'moment'

export interface GroupedMenus {
  [key: string]: { [key: string]: GOScheduleMenu[] }
}

export interface SearchGOMenusResponse {
  finalMenus: GOScheduleMenu[]
  groupedMenus: GroupedMenus | null
}

interface SearchGOMenusCoordinator {
  RestService: {
    post: (path: string, filters: any) => Promise<GOScheduleMenu[]>
  }
  HandleError: any
  pResponseGOMenus: (
    menus: GOScheduleMenu[],
    hqId: number,
    clientLongitude?: number,
    clientLatitude?: number,
    excludeClientSpecificMenus?: boolean,
  ) => SearchGOMenusResponse
  pRequestSearchGOMenusParams: (
    val: any,
    customValues: any,
    clientGeo: any,
    hqId: number,
  ) => any
}

export interface GOSearchMenusParams {
  availOn?: Moment | null
  avgMenuPriceGT?: number | null
  avgMenuPriceLT?: number | null
  avgMenuMarginGT?: number | null
  avgMenuMarginLT?: number | null
  avgRating?: number | null
  cuisines?: string[] | null
  clientId?: string | null
  clientName?: string | null
  earliestPickup?: number | null
  menucardCutoff?: number | null
  menuOrderingCapGT?: number | null
  menuOrderingCapLT?: number | null
  readyToHeat?: boolean | null
  vendorMaxItemsGT?: number | null
  vendorMaxItemsLT?: number | null
  lastScheduledLT?: number | null
  lastScheduledGT?: number | null
  distanceLT?: number | null
  avgItemRatings?: number | null
  longitude?: number
  latitude?: number
  hqId: number
  clientSettingsId?: string
  excludeClientSpecificMenus: boolean
  withinBudget?: boolean
}

export const SearchGOMenus =
  ({ RestService, pResponseGOMenus, HandleError }: SearchGOMenusCoordinator) =>
  async (
    params: GOSearchMenusParams,
  ): Promise<SearchGOMenusResponse | null> => {
    try {
      const menus = await RestService.post(
        '/group-orders/schedule-planner/menus',
        params,
      )

      return pResponseGOMenus(
        menus,
        params.hqId,
        params.longitude,
        params.latitude,
        params.excludeClientSpecificMenus,
      )
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export const SearchUniversalPreviewMenus =
  ({ RestService, pResponseGOMenus, HandleError }: any) =>
  async (params: SearchUniversalPreviewMenusReq) => {
    try {
      const menus = await RestService.get(
        '/group-orders/universal-menus-preview/menus',
        params,
      )

      return pResponseGOMenus(menus, params.hqId)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
